import React from 'react';
import { Flex, Label as BaseLabel } from '.';
import { Text as BaseText } from '@react-pdf/renderer';
import { useTheme } from '..';
import textVariants from './Text/textVariants';
import labelVariants from './Label/labelVariants';

const DynamicComponent = {
  Wrapper,
  Label,
  Value,
};
export default DynamicComponent;

export function Wrapper({
  orientation = 'vertical',
  variant = 'default',
  children,
  style,
  ...rest
}) {
  const { theme: styles } = useTheme();
  const dynamicComponentStyle =
    styles.components?.DynamicComponent?.[variant]?.[orientation].component;
  return (
    <Flex
      direction={orientation === 'vertical' ? 'column' : 'row'}
      style={[dynamicComponentStyle, style]}
      {...rest}
    >
      {children}
    </Flex>
  );
}

export function Label({
  orientation = 'vertical',
  variant = 'default',
  children,
  label,
  style,
}) {
  const { theme: styles } = useTheme();
  const baseStyle = styles.components?.Label
    ? {
        ...styles.components?.Label?.base,
        // Dynamic components use the default text style unless overriden in the DynamicComponent
        ...styles.components?.Label?.default,
      }
    : labelVariants[variant];
  const dynamicComponentStyle =
    styles.components?.DynamicComponent?.[variant]?.[orientation].label;
  return (
    <BaseLabel style={[baseStyle, dynamicComponentStyle, style]}>
      {label || children}
    </BaseLabel>
  );
}

export function Value({
  orientation = 'vertical',
  variant = 'default',
  children,
  style,
}) {
  const { theme: styles } = useTheme();
  const baseStyle = styles.components?.Text
    ? {
        ...styles.components?.Text?.base,
        // Dynamic components use the default text style unless overriden in the DynamicComponent
        ...styles.components?.Text?.default,
      }
    : textVariants[variant];
  const dynamicComponentStyle =
    styles.components?.DynamicComponent?.[variant]?.[orientation].value;
  return (
    <BaseText style={[baseStyle, dynamicComponentStyle, style]}>
      {children}
    </BaseText>
  );
}

/**
 * @typedef DynamicComponent
 * @property {string} orientation
 * @property {string} variant
 * @property {string} label
 */
